import React from "react";
import Button from "@amzn/awsui-components-react/polaris/button";
import EllipsisText from "./EllipsisText";
import "./EllipsisText.css";

/** One download button, icon plus the truncated file name. */
export default function FileDownloadButton({fileName, fallback = "File", loading = false, loadingText, onClick}) {
    return (
        <span className="fileDownloadCell">
            <Button className="fileDownloadButton" iconName="download" variant="inline-link"
                    loading={loading} loadingText={loadingText}
                    onClick={loading ? undefined : onClick}>
                <EllipsisText text={fileName} fallback={fallback} />
            </Button>
        </span>
    );
}
